var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 129,
    viewBox: "0 0 139 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.178 17.0675C75.1236 22.3255 64.6791 24.7664 54.2033 24.0726C26.8132 22.3372 9.72074 41.3049 6.68585 50.7975C3.1773 61.8171 5.38769 74.1383 11.0715 84.2382C16.7554 94.3381 25.6378 102.39 35.3974 108.742C42.9993 113.705 51.49 117.8 60.542 118.767C69.4128 119.715 78.3011 117.61 86.9322 115.394C98.0426 112.502 109.247 109.286 118.918 103.177C126.813 98.1965 134.04 89.7914 132.409 80.6749C131.017 72.9062 123.591 67.1852 122.333 59.3876C120.579 48.4778 131.356 39.3613 132.801 28.3995C134.485 15.6155 125.199 5.07019 116.346 5.00077C107.136 4.91979 94.1949 11.2077 84.178 17.0675Z",
    fill: "#EDF7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3125 29.8081H108.817L108.867 29.7487C110.245 28.108 110.999 26.0398 110.999 23.904C110.999 21.7683 110.245 19.7001 108.867 18.0593L108.817 18H43.3125L43.6382 18.3457C45.0985 19.9074 45.8874 21.9725 45.8373 24.1022C45.7873 26.232 44.9022 28.2584 43.3702 29.7508L43.3125 29.8081Z",
    fill: "#A3CBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7733 106H35.9648V25.0026C35.9646 24.1039 36.1428 23.214 36.4892 22.3836C36.8357 21.5532 37.3437 20.7988 37.9841 20.1633C38.6245 19.5278 39.3849 19.0238 40.2217 18.68C41.0585 18.3362 41.9554 18.1593 42.8611 18.1596H101.373C101.373 18.1596 107.446 17.8016 107.323 18.1596C103.063 18.2414 103.282 29.9677 103.282 29.9677V98.5494C103.281 100.525 102.49 102.42 101.082 103.817C99.6741 105.214 97.7645 105.999 95.7733 106Z",
    fill: "#003478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6867 106H30.1819L30.1324 105.941C28.7545 104.3 28 102.232 28 100.096C28 97.9602 28.7545 95.892 30.1324 94.2512L30.1819 94.1919H95.6867L95.3609 94.5376C92.3221 97.7842 91.8067 103.322 95.6867 105.994V106Z",
    fill: "#A3CBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2065 31.2585H50.5137V34.6565H91.2065V31.2585Z",
    fill: "#F7D77F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8699 88.9956H78.6758V90.1024H96.8699V88.9956Z",
    fill: "#004686"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8721 41.0393H44.8525V42.4202H96.8721V41.0393Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8721 47.8147H44.8525V49.1956H96.8721V47.8147Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8721 54.5923H44.8525V55.9732H96.8721V54.5923Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8721 61.3679H44.8525V62.7488H96.8721V61.3679Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8721 68.1433H44.8525V69.5242H96.8721V68.1433Z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8721 81.6965H44.8525V83.0774H96.8721V81.6965Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8721 74.9209H44.8525V76.3018H96.8721V74.9209Z",
    fill: "#E6E6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.d9c427765d82eb146512c6ccaa5805bf.svg";
export { ForwardRef as ReactComponent };